module.exports = __webpack_public_path__ + "img/圆形选中.6835498e.png";